import React, { Component } from 'react';
import moment from 'moment';

moment.locale('el');

class DateSelect extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      isOpen: false
    };

    this.onToggle = this.onToggle.bind(this);
  }

  onToggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render() {
    // Find index of current date
    const currentIndex = this.props.dateControls.findIndex((el) => {
      return el.date === this.props.date
    });

    const daysLen = this.props.dateControls.length;

    // check if next/prev exists
    const PREV = currentIndex > 0 ? currentIndex - 1 : null;
    const NEXT = currentIndex < daysLen - 1 ? currentIndex + 1 : null;

    const currentDayItem = this.props.dateControls.find( (d) => {
      return d['date'] === this.props.currentDay;
    });
    return (
      <div className={this.state.isOpen ? 'date-controls is-open' : 'date-controls'}>

        { PREV !== null &&
            <div
              className="disable-select date-controls_arrow date-controls_arrow--left"
              onClick={this.props.onDateChange}
              data-date={this.props.dateControls[PREV].date}>
                {this.props.dateControls[PREV].date_label}
            </div> }

        { NEXT !== null &&
            <div
              className="disable-select date-controls_arrow date-controls_arrow--right"
              onClick={this.props.onDateChange}
              data-date={this.props.dateControls[NEXT].date}>
                {this.props.dateControls[NEXT].date_label}
            </div> }
      
        <div className="disable-select date-controls_header" onClick={this.onToggle}>
          {/* {moment(new Date(this.props.currentDay)).format('dddd DD MMM GGGG')} */}
          {currentDayItem && currentDayItem.date_label}
          <span>Επιλογή ημερομηνίας</span>
        </div>

        <div className="date-controls_dropdown">
          <ul>
            {this.props.dateControls.map((el, i) =>{
              return (
                <li 
                  onClick={this.props.onDateChange} 
                  data-date={el.date} 
                  key={i} 
                  className={this.props.date === el.date ? 'active' : null}
                >
                  {el.date_label}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    )
  }

};

export default DateSelect;


// WEBPACK FOOTER //
// ./src/Components/DateSelect.js